import React from 'react'
import { Button } from 'antd'

const ButtonComponent = ({style,onClick,buttonName,icon,disabled}) => {
    return (
        <Button style={style} disabled={disabled ? disabled : ''} onClick={onClick} icon={icon} type='round'>{buttonName}</Button>
    )
}

export default ButtonComponent